import RespondentSettingsData from "./RespondentSettingsData"; // Import the data file

const respondentSettingsUtils = (productCategoryLabel) => {
    if (!productCategoryLabel) {
        return RespondentSettingsData.types_of_variable;
    }

    // Check if it's Skin Care or Hair Care
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryLabel?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryLabel?.toLowerCase();

    // Check if it's Deodorants, Oral Care, or Skin Cleansing
    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryLabel?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryLabel?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryLabel?.toLowerCase();

    // If it's Skin Care or Hair Care, hide "Additional Product Performance"
    if (isSkinCare || isHairCare) {
        return RespondentSettingsData.types_of_variable.filter((type) => type.value !== "ADDITIONAL_PRODUCT_PERFORMANCE");
    }

    // For Deodorants, Oral Care, and Skin Cleansing, show all options
    if (isDeodorants || isOralCare || isSkinCleansing) {
        return RespondentSettingsData.types_of_variable;
    }

    // Default: return all options
    return RespondentSettingsData.types_of_variable;
};

export default respondentSettingsUtils;
